import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { TranslationService } from '../../shared/services/translation/translation.service';
import { BalanceService } from '../../shared/balance/balance.service';
import { SessionService } from '../../shared/services/session/session.service';
import { TransactionListService } from '../../shared/services/transaction-list/transaction-list.service';
import { TransactionListElement } from '../../shared/domain/transaction-list-element';
import { DatePipe } from '@angular/common';
import { languageFactory } from '../../app.module';


@Component({
  moduleId: module.id,
  selector: 'vit-transaction-list',
  templateUrl: 'transaction-list.component.html',
  styleUrls: ['transaction-list.component.scss'],
  animations: [
    trigger('slideRight', [
      state('void', style({
        'margin-right': '-35px'
      })),
      state('show', style({
        'margin-right': '0'
      })),
      transition('void => show', animate('150ms linear')),
      transition('show => void', animate('100ms linear'))
    ])
  ]
})
export class TransactionListComponent implements OnInit {

  selectedTransaction:TransactionListElement = null;

  constructor(public sessionService:SessionService,
              public transactionListService:TransactionListService,
              public router:Router,
              public translationService:TranslationService,
              public balanceService: BalanceService) {
  }

  ngOnInit():void {
    setTimeout(() => {
      this.transactionListService.loadTransactionList();
    }, 1000);
  }

  isNoBet(transaction:TransactionListElement):boolean {
    return transaction.Type !== 1 && transaction.Type !== 0;
  }

  allowBarcodeView(transaction:TransactionListElement): boolean {
    return transaction.Type === 2 && transaction.CancelPossible;
  }

  stornoPossible(transaction:TransactionListElement):boolean {
    return transaction.CancelPossible && transaction.Type === 2;
  }

  toggleTransaction(transaction:TransactionListElement):void {
    if (this.selectedTransaction) {
      this.selectedTransaction = null;
    } else if (this.stornoPossible(transaction)) {
      this.selectedTransaction = transaction;
    }
  }

  stornoTransaction():void {
    this.transactionListService.stornoTransaction(this.selectedTransaction);
    this.selectedTransaction = null;
    setTimeout(() => {
      this.balanceService.updateBalance();
    }, 3000);
  }

  defineType(t:TransactionListElement, state:number, type:number):string {
    switch (type) {
      case 0:
        return this.translationService.translate("transactions.stake");
      case 1:
        return this.translationService.translate("transactions.win");
      case 2:
        switch (state) {
          case 4:
            return this.translationService.translate("transactions.storno");
          case 3:
            return this.translationService.translateArgs("transactions.disbursed", new DatePipe(languageFactory()).transform(t.OutDate, "dd.MM. HH:mm"));
          default:
            return this.translationService.translate("transactions.disburseRequested");
        }
      case 3:
        return this.translationService.translate("transactions.payin");
      default:
        return this.translationService.translate("transactions.stake");
    }
  }
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/punter-bar/+transaction-list/transaction-list.component.ts